import React from 'react';
import { makeStyles, createStyles, useTheme } from '@material-ui/core/styles';

const useStyles = ({colors}) => makeStyles(theme => createStyles({
    root: {
        position: 'relative',
        height: '100%',
        width: '100%'
    },
    heroSvg1: {
        position: 'absolute',
        width: '100%',
        top: '25px',
        left: '12px',
        '& path': {
            fill: 'none',
            stroke: colors[0],
            strokeWidth: '2px'
        }
    },
    heroSvg2: {
        position: 'absolute',
        width: '100%',
        top: '-20px',
        left: '10px',
        '& path': {
            fill: 'none',
            stroke: colors[1],
            strokeWidth: '2px'
        }
    }
}));

const PickOutline = ({
    rootStyles = {},
    colors = null
}) => {
    const theme=  useTheme();
    const classes = useStyles({
        colors: colors ? colors: [theme.palette.primary.main, theme.palette.secondary.main]
    })();

    return (
        <div className={classes.root} style={rootStyles}>
            <svg className={classes.heroSvg1} viewBox="0 0 1000 813.3333" alt="Pick border" title="Pick border">
                <path d="M1 406 C 1 273, 999 -433, 999 406 C 999 1246, 1 539, 1 406"/>
            </svg>
            <svg className={classes.heroSvg2} viewBox="0 0 1000 813.3333" alt="Pick border" title="Pick border">
                <path d="M1 406 C 1 273, 999 -433, 999 406 C 999 1246, 1 539, 1 406"/>
            </svg>
        </div>
    );
};
export default PickOutline;